import { BUSINESS } from "../data";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#030303] border-t border-zinc-800 py-12">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 flex flex-col md:flex-row justify-between gap-6">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 bg-[#FF3B30]" />
          <span className="font-display font-bold uppercase tracking-tight">{BUSINESS.name}</span>
        </div>
        <p className="text-zinc-500 text-sm">{BUSINESS.area} · {BUSINESS.phone}</p>
        <p className="text-zinc-600 text-sm">© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
      </div>
    </footer>
  );
}
